import { createTheme } from '@material-ui/core/styles';

export const colTheme = createTheme({
    palette: {
        type: 'light',
        primary: {
            main: '#58ab01',
            contrastText: '#FFFFFF',
        },
        secondary: {
            main: '#3f4a51',
            contrastText: '#FFFFFF',
        },
        divider: '#f2f4f8',
    },
});
